import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Header from "./components/Header"
import Hero from "./components/Hero"  
import ExchangeRates from "./components/ExchangeRates"
import ServicesSection from "./components/ServicesSection"
import WhyChooseUs from "./components/WhyChooseUs"
import RequirementsSection from "./components/RequirementsSection"
import AboutSection from "./components/AboutSection"
import Footer from "./components/Footer"
import AdminPanel from "./components/AdminPanel"
import Chatbot from "./components/Chatbot"
import "./index.css"

function LandingPage() {
  return (
    <div className="App">
      <Header />
      <Hero />  
      <ExchangeRates />
      <ServicesSection />
      <WhyChooseUs />
      <RequirementsSection />
      <AboutSection />
      <Footer />
      <Chatbot />
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App